export function triggerDownloadWithAnchorTag(url: string, fileName?: string) {
  const $a = document.createElement('a');
  $a.setAttribute('href', url);
  $a.setAttribute('target', '_blank');
  $a.setAttribute('rel', 'noreferrer');
  if (fileName) {
    $a.setAttribute('download', fileName);
  }
  $a.click();
  $a.remove();
}
